import React from 'react';
import { ChevronRight, ChevronLeft, RefreshCw } from 'lucide-react';

interface NavigationControlsProps {
    onNext: () => void;
    onPrevious: () => void;
    onRestart: () => void;
    currentIndex: number;
    totalSections: number;
    isFirst: boolean;
    isLast: boolean;
}

const NavigationControls: React.FC<NavigationControlsProps> = ({
    onNext,
    onPrevious,
    onRestart,
    currentIndex,
    totalSections,
    isFirst,
    isLast,
}) => {
    return (
        <div className="fixed bottom-0 left-0 right-0 max-w-6xl mx-auto z-50 bg-white/80 dark:bg-romantic-dark/80 backdrop-blur-md border-t border-gray-100 dark:border-gray-800 px-6 py-4 rounded-t-[2rem] shadow-[0_-10px_20px_rgba(0,0,0,0.05)]">
            <div className="flex justify-between items-center relative">
                <button
                    onClick={onPrevious}
                    disabled={isFirst}
                    className={`flex items-center space-x-2 px-6 py-3 rounded-full font-bold transition-all transform active:scale-95 ${isFirst
                        ? 'opacity-0 pointer-events-none'
                        : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'
                        }`}
                >
                    <ChevronLeft size={20} />
                    <span>Previous</span>
                </button>

                <div className="absolute left-1/2 -translate-x-1/2 hidden md:flex items-center space-x-2">
                    {Array.from({ length: totalSections }).map((_, i) => (
                        <div
                            key={i}
                            className={`h-1.5 rounded-full transition-all duration-300 ${i === currentIndex ? 'w-8 bg-primary-red' : 'w-2 bg-gray-200 dark:bg-gray-700'
                                }`}
                        />
                    ))}
                </div>

                {!isLast ? (
                    <button
                        onClick={onNext}
                        className="flex items-center space-x-2 px-8 py-3 rounded-full bg-primary-red text-white font-bold transition-all transform hover:scale-105 active:scale-95 shadow-lg shadow-red-200 dark:shadow-none"
                    >
                        <span>Next</span>
                        <ChevronRight size={20} />
                    </button>
                ) : (
                    <button
                        onClick={onRestart}
                        className="flex items-center space-x-2 px-8 py-3 rounded-full bg-primary-red text-white font-bold transition-all transform hover:scale-105 active:scale-95 shadow-lg shadow-red-200 dark:shadow-none"
                    >
                        <RefreshCw size={18} className="mr-2" />
                        <span>Restart</span>
                    </button>
                )}
            </div>

            <div className="mt-4 flex justify-center md:hidden">
                <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                    Journey of 50 Days
                </span>
            </div>
        </div>
    );
};

export default NavigationControls;
